import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    UpdateProductOptionInput,
    CreateProductOptionInput,
    ProductOption
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ProductOptionService {
    private amplifyClient = generateClient();

    constructor() {}

    async productOptionsByOwnOrder(ownOrder: string): Promise<ProductOption[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductOptionsByOwnOrder,
                    variables: {
                        ownOrder
                    }
                })
            ).data.ProductOptionsByOwnOrder.items;
            if (data) return data as ProductOption[];
        } catch (error) {
            console.error('Error finding ProductOptions:', error);
            return null;
        }
    }

    async getProductOption(id: string): Promise<ProductOption> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getProductOption,
                    variables: {
                        id
                    }
                })
            ).data.getProductOption;
            if (data) {
                return data as ProductOption;
            } else {
                const response = await this.createProductOption({ id });
                return response;
            }
        } catch (error) {
            console.error('Error finding ProductOptions:', error);
            return null;
        }
    }

    async createProductOption(
        input: CreateProductOptionInput
    ): Promise<ProductOption> {
        try {
            const productOption = (
                await this.amplifyClient.graphql({
                    query: mutations.createProductOption,
                    variables: {
                        input
                    }
                })
            ).data.createProductOption;
            if (productOption) return productOption as ProductOption;
        } catch (error) {
            console.error('Error creating productOptions:', error);
            return null;
        }
    }

    async updateProductOption(
        input: UpdateProductOptionInput
    ): Promise<ProductOption> {
        try {
            const productOption = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProductOption,
                    variables: {
                        input
                    }
                })
            ).data.updateProductOption;
            if (productOption) return productOption as ProductOption;
        } catch (error) {
            console.error('Error updating productOptions:', error);
            return null;
        }
    }
}
